import logo from './logo.svg';
import './App.css';
import FeatureSection from './components/FeatureSection';
import EmailCollect from './components/EmailCollect';
import HeroSection from './components/HeroSection';
import Showcase from './components/Showcase';
import TryInvoiceForm from './components/TryInvoiceForm';

function App() {
  return (
   
    <div className="bg-gradient-to-b from-[#0f172a] to-[#1e293b] text-white min-h-screen antialiased">
    {/* You can optionally move <head> into public/index.html */}
    {/* e.g. <title>InvokeApi – Modular API Toolbox</title> */}
    <HeroSection/>
    <FeatureSection/>
    <Showcase/>
    <TryInvoiceForm/>
    <EmailCollect/>
  </div>
  );
}

export default App;
